/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';
import NoData from '../../assets/NoData/NoData';
import { selectStyles } from '../../utils/const';
import * as actions from '../../actions/umk';
import { cathList } from '../../actions/cathedra';
import { fetchMetaCourseForUmk } from '../../actions/educationWorkPrograms';
import { getStudyYear } from '../../actions/encryptionKeys';

const emptyOption = { value: 0, label: "Все", name: "Все" };

const UmkTeacher = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // Selectors
  const curriculum = useSelector(state => state.umk.curriculum);
  const disciplines = useSelector(state => state.umk.disciplines);
  const umk = useSelector(state => state.umk.umkList);
  const cafedraList = useSelector(state => state.cathedra.list);
  const metaCourse = useSelector(state => state.educationWorkPrograms.discipline);
  const yearList = useSelector(state => state.encryptionKeys.studyYears);

  // State для ID фильтров
  const [selectedYearId, setSelectedYearId] = useState(location.state?.selectedYearId || 0);
  const [selectedCafedraId, setSelectedCafedraId] = useState(location.state?.selectedCafedraId || 0);
  const [selectedMetaCourseId, setSelectedMetaCourseId] = useState(location.state?.selectedMetaCourseId || 0);
  const [selectedCurriculimId, setSelectedCurriculimId] = useState(location.state?.selectedCurriculimId || 0);
  const [selectedDisciplineId, setSelectedDisciplineId] = useState(location.state?.selectedDisciplineId || 0);

  // State для объектов Select
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedCafedra, setSelectedCafedra] = useState(null);
  const [selectedMetaCourse, setSelectedMetaCourse] = useState(null);
  const [selectedCurriculum, setSelectedCurriculum] = useState(null);
  const [selectedDiscipline, setSelectedDiscipline] = useState(null);

  // Initial load - загружаем справочники
  useEffect(() => {
    dispatch(getStudyYear());
    dispatch(cathList(0));
  }, []);

  // Загрузка учебных планов при изменении года, кафедры или метакурса
  useEffect(() => {
    dispatch(actions.fetchCirriculumForUmk(selectedYearId, selectedCafedraId, selectedMetaCourseId));
  }, [selectedYearId, selectedCafedraId, selectedMetaCourseId]);

  // Загрузка метакурсов при изменении кафедры или учебного плана
  useEffect(() => {
    dispatch(fetchMetaCourseForUmk(selectedCafedraId, selectedCurriculimId));
  }, [selectedCafedraId, selectedCurriculimId]);

  // Загрузка дисциплин РПД при изменении фильтров
  useEffect(() => {
    const filters = {
      idcurriculum: selectedCurriculimId || 0,
      idmetacourse: selectedMetaCourseId || 0,
      idcathedra: selectedCafedraId || 0,
      xp_key: selectedYearId || 0
    };
    dispatch(actions.fetchDisciplines(filters));
  }, [selectedCurriculimId, selectedMetaCourseId, selectedCafedraId, selectedYearId]);

  // Загрузка УМК при изменении учебного плана или дисциплины
  useEffect(() => {
    dispatch(actions.fetchUmk(selectedCurriculimId, selectedDisciplineId, true));
  }, [selectedCurriculimId, selectedDisciplineId]);

  // Handlers
  const handleSelectYear = (option) => {
    setSelectedYear(option);
    setSelectedYearId(option?.value || 0);
  };

  const handleSelectCafedra = (option) => {
    setSelectedCafedra(option);
    setSelectedCafedraId(option?.value || 0);
    // Сбрасываем Учебный план Дисциплина Дисциплина РПД при смене кафедры
    setSelectedDiscipline(null);
    setSelectedDisciplineId(0);
    setSelectedMetaCourse(null);
    setSelectedMetaCourseId(0);
    setSelectedCurriculum(null);
    setSelectedCurriculimId(0);
  };

  const handleSelectMetaCourse = (option) => {
    setSelectedMetaCourse(option);
    setSelectedMetaCourseId(option?.value || 0);
  };

  const handleSelectCurriculum = (option) => {
    setSelectedCurriculum(option);
    setSelectedCurriculimId(option?.value || 0);
    // Сбрасываем дисциплину при смене учебного плана
    setSelectedDiscipline(null);
    setSelectedDisciplineId(0);
  };

  const handleSelectDiscipline = (option) => {
    setSelectedDiscipline(option);
    setSelectedDisciplineId(option?.value || 0);
  };

  const goToCard = (id) => () => {
    history.push({
      pathname: `/umkTeacher/${id}`,
      state: {
        id,
        params: {
          selectedCurriculimId,
          selectedDisciplineId,
          selectedCafedraId,
          selectedMetaCourseId,
          selectedYearId
        }
      }
    });
  };

  const renderUmk = (plan, index) => {
    return (
      <tr key={index} onClick={goToCard(plan.id)} className="pointer">
        <td>{plan['Дисциплина'] || '-'}</td>
        <td>{plan['Факультет'] || '-'}</td>
        <td>{plan['Направление подготовки'] || '-'}</td>
        <td>{plan['Военная специальность'] || '-'}</td>
        <td>{plan['Специализация'] || '-'}</td>
        <td>{plan['Учебный план'] || '-'}</td>
      </tr>
    );
  };

  return (
    <div className="umkT">
      <p className="captions" style={{ marginBottom: '20px' }}>Электронные учебно-методические комплексы дисциплин</p>
      <div className="plans" >

        <div className="umkT-selector">
          <span>Учебные года</span>
          <div className="inputs__input CURR-input">
            <Select
              placeholder='Все'
              noOptionsMessage={() => "ничего не найдено"}
              styles={selectStyles}
              options={[emptyOption, ...(Array.isArray(yearList) ? yearList.map(el => ({ label: el.name, value: el.xp_key })).reverse() : [])]}
              onChange={handleSelectYear}
              value={selectedYear}
            />
          </div>
        </div>

        <div className="umkT-selector">
          <span>Кафедра</span>
          <div className="inputs__input CURR-input">
            <Select
              placeholder='Все'
              noOptionsMessage={() => "ничего не найдено"}
              styles={selectStyles}
              options={[emptyOption, ...(Array.isArray(cafedraList) ? cafedraList.map(el => ({ label: el.cathedra, value: el.idcathedra })) : [])]}
              onChange={handleSelectCafedra}
              value={selectedCafedra}
            />
          </div>
        </div>


        <div className="umkT-selector">
          <span>Учебный план</span>
          <div className="inputs__input CURR-input">
            <Select
              placeholder='Все'
              noOptionsMessage={() => "ничего не найдено"}
              styles={selectStyles}
              options={[emptyOption, ...(curriculum || [])]}
              onChange={handleSelectCurriculum}
              value={selectedCurriculum}
            />
          </div>
        </div>

        <div className="umkT-selector">
          <span>Дисциплина</span>
          <div className="inputs__input CURR-input">
            <Select
              placeholder='Все'
              noOptionsMessage={() => "ничего не найдено"}
              styles={selectStyles}
              onChange={handleSelectMetaCourse}
              value={selectedMetaCourse}
              options={[emptyOption, ...(Array.isArray(metaCourse) ? metaCourse.map(el => ({ label: el.name, value: el.id })) : [])]}
            />
          </div>
        </div>

        <div className="umkT-selector">
          <span>Дисциплина РПД</span>
          <div className="inputs__input CURR-input">
            <Select
              placeholder='Все'
              noOptionsMessage={() => "ничего не найдено"}
              styles={selectStyles}
              options={[emptyOption, ...(disciplines || [])]}
              onChange={handleSelectDiscipline}
              value={selectedDiscipline}
            />
          </div>
        </div>

      </div>
      {umk && umk.length ?
        <table className="umkT-table mt-10">
          <thead>
            <tr>
              <th>Дисциплина</th>
              <th>Факультет</th>
              <th>Направление подготовки</th>
              <th>Военная специальность</th>
              <th>Специализация</th>
              <th>Учебный план</th>
            </tr>
          </thead>
          <tbody>{umk.map(renderUmk)}</tbody>
        </table>
        : <NoData text='данные отсутствуют' />
      }

    </div>
  );
};

export default UmkTeacher;
